import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FunctionHandlerService } from '../function-handler/function-handler.service';
import { ModuleUrl } from '../../utils/modules-urls.enum';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(private functionHandler: FunctionHandlerService) { }

  handleError(error: HttpErrorResponse) {
    switch (error.status) {
      case 0:
        // Sin conexion
        this.functionHandler.handle('MODAL','NOCONNECTION');
        break;
      case 401:
        this.functionHandler.handle('NAVIGATE_IN',ModuleUrl.RUT_VALIDATION);
        break;
      case 500:
        this.functionHandler.handle('MODAL','INTERNAL_SERVER_ERROR');
        break;
      default:
        this.functionHandler.handle('PAGE','UNESPECTED')
        break;
    }
  }
}
